module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig3",
      "src": "images/chap3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_vm._v("Ought not a Minister to have, first, a good understanding, a clear apprehension, a sound judgment, and a capacity of reasoning with some closeness?")]), _vm._v(" "), _c('div', {
    staticClass: "exer_source"
  }, [_c('b', [_vm._v("JOHN WESLEY")])])]), _vm._v(" "), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_vm._v("We live in what may be the most anti-intellectual period in the history of Western civilization. We must have passion—indeed hearts on fire for the things of God. But that passion must resist with intensity the anti-intellectual spirit of the world.")]), _vm._v(" "), _c('div', {
    staticClass: "exer_source"
  }, [_c('b', [_vm._v("R. C. SPROUL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_c('b', [_vm._v("“I just don’t understand you. ")])]), _vm._v("How can anyone with your education, who reads as much as you, believe the things you believe? How can you possibly believe in God, a kindly ‘grandfather in the sky,’ when you see the suffering in the world caused by AIDS and tsunamis and famines and wars? You understand a lot about modern science—how can you deny evolution and believe there is anything more to the ‘real you’ than your body and your brain? You must know that miracles—"), _c('i', [_vm._v("violations ")]), _vm._v("of the laws of nature—are impossible. How can you believe that ‘spooky’ things like angels and demons are real? And your claims to know absolute truth—don’t get me started! Given everything we know about all the different religions and cultures in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("the world, how can you be so arrogant to believe that any one religion or morality is true and not merely a useful, culturally constructed fiction?”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Versions of these challenges to Christian faith are replayed repeatedly, day after day; doubtless, you have encountered them in some form. And if you have thought about the challenges much, you have thought philosophically. For the nature of the challenges is not really scientific or theological or anthropological, but philosophical.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Indeed, your philosophical thinking probably started long ago. At some time you asked yourself whether something was real or what was real. You asked what you know or how you know something. And you asked what was the right thing to do in some situation or how you should live your life. These questions lie at the heart of philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So what is philosophy? "), _c('i', [_vm._v("Philosophy is thinking critically about questions that matter. ")]), _vm._v("Conceived this way, philosophy is something everyone does. Everyone has beliefs about what is real, what is valuable, and how we come to know such things. For most people, such fundamental beliefs are largely unexamined and perhaps even mutually inconsistent, but in forming such beliefs and acting on them, everyone is doing philosophy. At a more developed level, philosophy refers to a body of knowledge, often the subject matter of college courses, which organizes and presents the thinking of major thinkers throughout the ages about such things as reality, values, and knowledge.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At a still more refined level, philosophy is the specialized activity engaged in by certain “professional thinkers” who build on the thought of those who have gone before, utilizing certain tools and methods, with the goal of developing, presenting, and defending carefully examined conclusions about reality, values, and knowledge. Since philosophy is above all concerned with discerning the truth about these things, it is natural that philosophy has influenced every corner of life—both inside and outside academia—and that philosophical terms, tools, arguments, and conclusions can be found in almost any book pulled from the library shelf.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Unfortunately the terms and tools are sometimes misused, and the arguments and conclusions often misrepresented. As with any discipline, the professional can quickly spot the errors, but to the untrained eye, all appears as it should.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("We are deeply concerned about the impact of philosophy on theology. The medieval theologians believed that theology was the queen of the sciences (that is, of domains of knowledge) and philosophy was her handmaid. The development of theology in both the Eastern and the Western churches has been deeply affected by philosophy, and theology in turn has affected Western philosophy. But since the Enlightenment, roughly, the flow has been one way, from philosophy to theology, and for the most part it has been corrosive to orthodox theology.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In our day, theology has largely been banished from the university (even many Christian colleges have reduced the required credits in Bible and theology), and philosophy has been largely ignored (liberal arts curricula in general have been weakened to make room for more “practical” courses). Couple this with a trendy anti-intellectualism in many evangelical churches, and the result is that most young women and men who desire to enter seminary or join the staff of a parachurch ministry are ill prepared to understand and engage the philosophical aspects of biblical studies, in particular, and the culture in which they minister, in general. And most pastors have neither the time nor the background to keep up with trends in contemporary philosophy, even where it has a direct bearing on theology and ministry."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Our goal in this “philosophical toolkit” is to redress this problem by providing you with a brief, nontechnical, practical guide to selected philosophical terms and concepts and to illustrate their importance and usefulness in teaching the Bible and doing theology in light of contemporary issues."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" We are not aiming at making you a professional philosopher. But we do want you to be able to recognize and understand the philosophy that you come across every day so that you can be more philosophically discriminating, whatever your particular path of service to our Lord.")]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("LOGIC")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We have often (too often!) heard someone say, “Why is logic so important in theology? You make it sound as if logic is even over God!” We believe the question reflects a common misunderstanding of logic.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If God did not exist, then logic would not exist (nor would anything else, for that matter). But if God does exist, then a whole lot of other things also exist, including the laws of logic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" For example, consider the law of identity: God is who he is, and not another God. Consider, too, the law of noncontradiction: God cannot be both good and not good. These laws (and other things that exist timelessly) would not exist if God did not exist, so they depend on God for their existence. But they were not created by God in the sense that he could have made them otherwise. So to say that the laws of logic apply to God is not to make logic sovereign over God. It is simply to recognize that once something exists, then many other things also exist that cannot be any other way.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another objection we hear often is this: “Well, there are many different logics. How can we tell which one is the right one? Isn’t that pretty arbitrary?” Again, we believe, this rests on a misunderstanding.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The short answer is yes, there are many different logics. But we should keep two points in mind. First, there are also many different algebras and many different geometries. (Mathematicians and logicians are quite creative!) Some of these different systems were devised for dealing with specific problems and do not claim universal validity (e.g., “fuzzy” logic, versions of multivalent logic, and many systems of abstract algebra). Second, none of these systems could have been “built” apart from certain fundamental “laws of thought.” (If the law of noncontradiction did not hold universally, we could not even claim that there were different systems!)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A final objection goes this way: “Your logic is a relic of the male-dominated West, and it ignores Eastern logic and feminist logic, for example.” Again, we believe this reflects a deep misunderstanding.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With regard to “Eastern logic,” there really is no such thing. It is true that certain strands of Hinduism and Buddhism teach that contradiction lies at "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("the heart of reality, that on the path to enlightenment one must learn to embrace contradiction. But as Mortimer Adler pointed out, as long as Hindus and Buddhists accept the results of modern science and technology, they are tacitly affirming the law of noncontradiction, which lies at the very foundation of science."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As for “feminist logic,” this is almost certainly a matter of emphasis and values, not different logics. We may grant, for the sake of argument, that women are in general more relational and more emotionally connected, while men are more objective and linear in their thought. But of course women can use objective logic when required, and men can learn to value relationships and emotional connections. Difference in emphasis is not difference in kind.")]), _vm._v(" "), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("THE THREE LAWS"), _c('br'), _vm._v("\n          O")]), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("F THOUGHT")])])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("The law of identity")])]), _vm._v(": Something is what it is and not anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("The law of noncontradiction")])]), _vm._v(": For any property "), _c('i', [_vm._v("F")]), _vm._v(", nothing can be both "), _c('i', [_vm._v("F ")]), _vm._v("and not-"), _c('i', [_vm._v("F ")]), _vm._v("at the same time and in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("The law of the excluded middle")])]), _vm._v(": Any proposition is either true or false and not something in between.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The laws of thought. ")])]), _vm._v("Three logical laws are so fundamental that they are sometimes called "), _c('i', [_vm._v("laws of thought. ")]), _vm._v("We’ve already mentioned two of them, the law of identity and the law of noncontradiction. The third is the law of the excluded middle.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These laws are sometimes called "), _c('i', [_vm._v("axioms ")]), _vm._v("or "), _c('i', [_vm._v("fundamental principles")]), _vm._v(". They cannot be proved, but their truth is inescapable, for as soon as you try to disprove any one of them, you find you must assume it. Suppose, for example, you were to try to disprove the law of identity. Then you assume you are trying to disprove the law of identity and not the law of gravity; the law of identity is what it is, and it is not the law of gravity. Or suppose you were trying to disprove the law of noncontradiction. That is, you’d be trying to prove that it was false that something could not be both true and false at the same time and in the same way. But that, of course, assumes the very law you’re trying to disprove. (There’s a famous story about the great Princeton logician Saul Kripke. In a meeting of faculty from other departments, several were trying to argue that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("the law of noncontradiction should be done away with, as it was a relic of male-dominated, Western, polarizing thinking. Kripke replied, “Good, let’s get rid of it. Then we can keep it too.”)")])]), _vm._v(" "), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("VALIDITY, SOUN")]), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("DNESS,"), _c('br'), _vm._v("\n          COGENCY")])])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("Validity")])]), _vm._v(": An argument is formally valid if its form is such that the conclusion follows from the premises according to the laws of logic. An argument whose form violates the laws of logic is invalid, even if the conclusion is true. An argument is informally valid if it contains no informal fallacies.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("Soundness")])]), _vm._v(": An argument that is valid (that is, has the proper form) and has true premises is sound. An argument that has false premises is unsound, whether or not the form is valid and even if the conclusion is true.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("Cogency")])]), _vm._v(": An argument is cogent for a person if that person believes that it is valid and that the premises are more likely than their denial. Cogency is person-relative, and a sound argument may seem to a person not to be cogent (thus explaining why not everyone accepts the conclusion of a sound argument).")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Do these laws have anything to do with theology? Most certainly! In Isaiah 45:5, for instance, God makes a strong claim: “I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", and there is no other; apart from me there is no God.” Now, according to the law of identity, it is Yahweh (the Lord) who speaks, and Yahweh is not Krishna or Brahmin or Baal. According to the law of noncontradiction, the Lord cannot be the only God and also just one of many gods. And according to the law of the excluded middle, either it is true that the Lord is the only God or it is false; it cannot be the case that “the Lord is the only God” is true for Christians but false for Buddhists. (For more on the law of identity, see "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-003"
    }
  }, [_vm._v("chapter two")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Arguments. ")])]), _vm._v("A philosophical argument is not a heated quarrel, nor is it a rhetorical contest. Philosophical arguments are not decided on the basis of majority vote or how someone feels about an argument. Arguments in philosophy consist in a set of premises that lead to a conclusion. There is a fundamental difference between "), _c('i', [_vm._v("deductive ")]), _vm._v("and "), _c('i', [_vm._v("inductive ")]), _vm._v("arguments. Below, we’ll examine inductive arguments, but here we’ll deal with deductive arguments specifically. In a deductive argument, the relation between the premises and the conclusion is a logical matter. The truth of the premises guarantees the truth of the conclusion; "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("or, put differently, if the premises are true, the conclusion must be true. Still, not just any old set of premises together with a conclusion form a good argument. A successful argument—one that persuades someone of a true conclusion—must be valid, sound, and cogent.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Validity")]), _vm._v(". An argument is valid if its "), _c('i', [_vm._v("form ")]), _vm._v("is correct—that is, if the conclusion follows from the premises according to the laws of logic. An argument that does not have a correct form is invalid, even if the conclusion is true. Here’s an example of an invalid argument:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("1. Some politicians are liars.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("2. Jessica is a not a politician.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("3. Therefore, Jessica is not a liar.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even assuming that Jessica is not a politician, (3) doesn’t follow from (1) and (2). Here’s another example:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("1. If Jupiter is the fifth planet from the sun, then it is the largest planet.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("2. Jupiter is the largest planet.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("3. Therefore, Jupiter is the fifth planet from the sun.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even though each of the premises and the conclusion is true, this is an invalid argument because its form is incorrect. We say that the argument commits a "), _c('i', [_vm._v("formal fallacy")]), _vm._v(". Shortly we’ll explain what is wrong with the form of these two arguments (if it isn’t apparent to you already). The point is that the validity of an argument depends on the form of the premises and the conclusion, not their truth.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Soundness")]), _vm._v(". Why worry about validity? Simple. The conclusion of a valid argument is guaranteed to be true if the premises are true. An argument that has a valid form together with true premises is called "), _c('i', [_vm._v("sound")]), _vm._v(". The conclusion of a sound argument is guaranteed to be true. So in evaluating arguments, it is very important to ensure the argument has the proper form (validity) and the premises are true (soundness).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Of course, it is not always apparent whether a premise is true, and often it may be very difficult to tell. So philosophical arguments generally spend most of the time trying to show in some way that the premises are indeed true (or, at the very least, are more probable than their denials), and that leads to the issue of cogency.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('i', [_vm._v("Cogency")]), _vm._v(". A cogent argument is one for which the validity and soundness are apparent to the reader, and so she accepts the conclusion of the argument. Unfortunately, this complicates things. No conclusion can be stronger than the strength of the weakest premise, and it frequently happens that we think we have stronger reasons to reject a conclusion than to accept at least one of the premises. In that case, even if we cannot demonstrate the falsity of a premise, and even if the argument is valid, it will not be cogent for us. It will not demand acceptance or compel belief. Cogency, then, is person-relative. Many factors—psychological, personal, volitional, prejudicial, or theological (think of original sin or the work of the Holy Spirit)—enter into the mix when a person evaluates an argument. Especially in the case where the premises are not clearly and undeniably true, a perfectly valid argument may lack cogency for someone. Some arguments are so complicated, the logic so sophisticated, that only specialists are able to grasp them. Such arguments may lack cogency even for the average philosopher. In part this explains why two people can look at the same argument and disagree completely about whether it is a good argument."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is important for a couple of reasons. First, you may be deeply convinced that a particular argument for, say, the existence of God is sound, but you find that someone—a very smart friend, perhaps—rejects it. That doesn’t automatically mean the argument is a bad argument and you should give it up. Rather, other factors may be at work in your friend’s life that make it more plausible to him to deny the conclusion that God exists than to accept the validity of the argument or the truth of the premises, even if he can’t say just where the argument went wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Second, you may encounter an argument in your study that leads to a conclusion you find dead wrong. It just isn’t cogent for you. If you have stronger reasons to reject the conclusion of the argument than you do to accept its soundness, you are within your intellectual rights not to accept the conclusion. But—and this should go without saying—the fact that we don’t like a particular conclusion is not in itself a sufficient reason to reject it. We must be honest with the argument and with ourselves, and sometimes that means doing some hard thinking and research to discover just where the argument went wrong. Or we may discover that we were wrong and accept the conclusion after all.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One final matter before moving on has to do with the notion of "), _c('i', [_vm._v("certainty")]), _vm._v(". Sometimes authors use the term "), _c('i', [_vm._v("certain ")]), _vm._v("to refer to a proposition that is infallible (such as the proposition “Anything that is red is colored”). But more often, and in the general population, certainty is a psychological predicate, indicating that someone believes a proposition and entertains no doubt about it. We have all been certain about some false propositions (and in all likelihood we are right now as well). “Certain” often serves a rhetorical purpose in an argument, and just because an author labels a premise as certain does not mean it is beyond question. In short, certainty belongs to persons, truth to propositions.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Valid forms of deductive arguments (and associated fallacies). ")])]), _vm._v("We begin this section with a caveat: this is not nearly a complete survey of valid argument forms."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Nevertheless, a few merit attention. In what follows, the letters "), _c('i', [_vm._v("p")]), _vm._v(","), _c('i', [_vm._v(" q")]), _vm._v(", and "), _c('i', [_vm._v("r ")]), _vm._v("represent propositions (for now, think of a proposition as a declarative sentence). Several of the forms use an "), _c('i', [_vm._v("if, then ")]), _vm._v("form: If "), _c('i', [_vm._v("p")]), _vm._v(", then "), _c('i', [_vm._v("q. ")]), _vm._v("This is called a "), _c('i', [_vm._v("conditional statement")]), _vm._v(";"), _c('i', [_vm._v(" p ")]), _vm._v("is called the "), _c('i', [_vm._v("antecedent")]), _vm._v(", and "), _c('i', [_vm._v("q ")]), _vm._v("is called the "), _c('i', [_vm._v("consequent")]), _vm._v(". In addition, we’ll use the standard symbol ~ (the tilde) to stand for "), _c('i', [_vm._v("not")]), _vm._v(". For each form below we’ll use both symbolic notation and provide an example. For the sake of illustration we’ve used simple examples, but most arguments you encounter will not be so simple. See if you can think of other more complicated sentences to substitute for "), _c('i', [_vm._v("p")]), _vm._v(","), _c('i', [_vm._v(" q")]), _vm._v(", and "), _c('i', [_vm._v("r ")]), _vm._v("and reflect carefully about the resulting argument.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('i', [_vm._v("Modus ponens")]), _vm._v(":")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche retrait_autre"
  }, [_c('i', [_vm._v("Modus ponens ")]), _vm._v("is perhaps the most intuitively obvious inference pattern; anyone who thinks about it will see that it is clearly valid.")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If "), _c('i', [_vm._v("p")]), _vm._v(", then "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If Mary has a sister, then Mary is a sibling.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("p")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mary has a sister.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore Mary is a sibling.")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The associated fallacy is that of "), _c('i', [_vm._v("affirming the consequent")]), _vm._v(". One states a conditional, claims that the consequent is true, and concludes that the antecedent must be true. But this is clearly invalid:")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-002"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If "), _c('i', [_vm._v("p")]), _vm._v(", then "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If Mary has a sister, then Mary is a sibling.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("q")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mary is a sibling.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore "), _c('i', [_vm._v("p ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore Mary has a sister.")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("(Of course, Mary could be a sibling who has only brothers.)")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Modus tollens")]), _vm._v(":")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-003"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If "), _c('i', [_vm._v("p")]), _vm._v(", then "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If Mary has a sister, then Mary is a sibling.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("~q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mary is not a sibling.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore "), _c('i', [_vm._v("~p ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore Mary does not have a sister.")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The associated fallacy here is "), _c('i', [_vm._v("denying the antecedent")]), _vm._v(". Again, the fallacy should be clear:")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-004"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If "), _c('i', [_vm._v("p")]), _vm._v(", then "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If Mary has a sister, then Mary is a sibling.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("~"), _c('i', [_vm._v("p ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mary does not have a sister.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore ~"), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore Mary is not a sibling.")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Hypothetical syllogism")]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-005"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If "), _c('i', [_vm._v("p")]), _vm._v(", then "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If it’s snowing, then it’s below 32°.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If "), _c('i', [_vm._v("q")]), _vm._v(", then "), _c('i', [_vm._v("r ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("If it’s below 32°, then it’s cold.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore if "), _c('i', [_vm._v("p")]), _vm._v(", then "), _c('i', [_vm._v("r ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore if it’s snowing, then it’s cold.")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('i', [_vm._v("Disjunctive syllogism")]), _vm._v(":")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-006"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("p ")]), _vm._v("or "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Either Bill is in his apartment or he is out.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("~"), _c('i', [_vm._v("p ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Bill is not in his apartment.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore Bill is out.")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Here the "), _c('i', [_vm._v("or ")]), _vm._v("statement (called a "), _c('i', [_vm._v("disjunction")]), _vm._v(") is assumed to be true. So if one of the terms (“disjuncts”) is false, the other must be true. There’s an associated fallacy here also, but it is not a formal fallacy—that is, it is not a matter of an incorrect form. It’s the informal fallacy of "), _c('i', [_vm._v("false dilemma")]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-007"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("p ")]), _vm._v("or "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Either Bill is in his apartment or he is in the library.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("~"), _c('i', [_vm._v("p ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Bill is not in the library.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore "), _c('i', [_vm._v("q ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Therefore Bill is in his apartment.")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Remember that the truth of the conclusion depends on the truth of the premises. A disjunctive syllogism relies on an exclusive sense of "), _c('i', [_vm._v("or ")]), _vm._v("such that the two alternatives are the only ones possible. The disjunction “"), _c('i', [_vm._v("p ")]), _vm._v("or "), _c('i', [_vm._v("q")]), _vm._v("” is true if and only if "), _c('i', [_vm._v("p ")]), _vm._v("is true, or "), _c('i', [_vm._v("q ")]), _vm._v("is true, or both are true. If, in our example, it is possible that Bill is en route, then the conclusion will not follow. In such a case, where the disjunction “"), _c('i', [_vm._v("p ")]), _vm._v("or "), _c('i', [_vm._v("q")]), _vm._v("” does not express mutually exclusive possibilities, the premise presents a false dilemma.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We have pointed out only four of nine rules of inference that determine valid deductive argument forms, but these are perhaps the four most "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("common. (As an exercise, see how many you can identify in comments on social media.) We’ve also noted two associated formal fallacies and one informal fallacy. As might be expected, it turns out that an argument can go wrong in many ways even if it is in the correct form. These ways are called "), _c('i', [_vm._v("informal fallacies")]), _vm._v(". There is no complete list of informal fallacies, perhaps because there is no end to the creativity of illogical people! But the following survey should be helpful in recognizing common informal fallacies (in addition to false dilemma, discussed above).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Informal fallacies. ")])]), _vm._v("Perhaps the most frequent informal fallacy, and therefore the one to be most wary of, is the one with which we begin.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Begging the question (petitio principii)")]), _vm._v(". It has become somewhat common for people to use the phrase "), _c('i', [_vm._v("and that begs the question ")]), _vm._v("in the sense of “that invites the question” or “that makes me wonder.” The fallacy of begging the question is quite different: it is circular reasoning. An argument begs the question if the conclusion is somehow smuggled into or assumed by one of the premises. Note how in this example the conclusion is incorporated into a premise:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“I’m all for women having equal rights,” said pro wrestler Mad Mountain, “but I repeat: a woman shouldn’t be a pro wrestler, since wrestlers are men!”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Equivocation")]), _vm._v(". Another very common informal fallacy is equivocation. Equivocation happens when a term is used in a different sense in two premises.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“Officer, I didn’t rob the bank [of America]. I swear, I wasn’t anywhere near the bank [of the river] yesterday!”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Equivocations are sometimes hard to spot. By carefully defining the terms of the argument, we can avoid equivocation in our own arguments.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Appeal to pity (argumentum ad misericordiam)")]), _vm._v(". Appeal to pity is another common mistake.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“Ladies and gentlemen of the jury, you must find it in your hearts to acquit my client of killing his parents. Remember, he is a poor orphan!”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("(Note how often you find this fallacy in arguments favoring abortion, embryonic stem cell research, physician-assisted suicide, and many other issues in bioethics.)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Ad hominem")]), _vm._v("."), _c('i', [_vm._v(" Ad hominem ")]), _vm._v("(against the person) arguments frequently find their place in political debate.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("“It’s too bad that Senator Bullmoose cannot see that his bill will steal from the poor and pay the rich. His holier-than-thou attitude toward labor unions smacks of bigotry and condescension.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We should watch ourselves closely on this one. The fact that someone is an evil person does not in itself invalidate anything he says. (Even Hitler probably said that 2 + 2 = 4. In German, of course.)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Appeal to the people (argumentum ad populam)")]), _vm._v(". This can take several forms, but a very common form is the use of opinion polls:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“Eighty-two percent of voters surveyed believe that Senator Bullmoose is a bigoted thief.”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Whether he is or isn’t, such premises have a bandwagon effect—people think they should believe what the majority believes.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Argument from ignorance (argumentum ad ignorantium)")]), _vm._v(". This fallacy involves citing the absence of evidence for a proposition as evidence against it. But of course absence of evidence is not evidence of absence.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“In spite of 150 years of searching, no ‘missing link’ fossil has been found. Therefore Darwinism is false.”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Straw man")]), _vm._v(". A straw man is the distortion of an opponent’s position so that it can more easily be attacked. By destroying the straw man, the impression is given that the real argument has been defeated.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“Jones claims that the war in Iraq does not meet the criteria for a just war. Does Jones want us to believe that the terrorists care about just war theory? Does he expect us to stop checking for weapons at airports, to bring home all our military forces and to wait, cringing, for the next attack?”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There are a number of other informal fallacies that we’ll name but not illustrate. They include "), _c('i', [_vm._v("hasty generalization")]), _vm._v(", "), _c('i', [_vm._v("false cause")]), _vm._v(", "), _c('i', [_vm._v("slippery slope")]), _vm._v(", "), _c('i', [_vm._v("weak analogy")]), _vm._v(", and "), _c('i', [_vm._v("complex question")]), _vm._v(". (Details can be found in most books on logic or critical thinking.)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In summary, a good argument must have a logically correct form, have true premises, be cogent to the reader, and avoid informal fallacies. You might be surprised just how much effort philosophers devote to crafting good arguments for their position and to finding the flaws in arguments they oppose. But the effort is worth it—for philosophers and for you as well.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Remember, the truth of God is not well served by bad arguments or sloppy thinking!")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Inductive arguments. ")])]), _vm._v("To this point we have been considering deductive arguments, those which, if the form is valid and the premises are sound, guarantee a true conclusion. Inductive arguments form a second and important class of logical arguments. In an inductive argument, the truth of the premises together with the absence of fallacies does not guarantee the truth of the conclusion. The conclusion of an inductive argument is probable, given the truth of the premises.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is important to point out a common misunderstanding at this point. There is a difference between the truth of a proposition (be it a premise or a conclusion) and the degree of probability we attach to the proposition. Since the conclusion of an argument can be no more certain than the premises, we may find ourselves having more confidence in the conclusion of an inductive argument than in the conclusion of a valid deductive argument.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Inductive arguments do not fit into neat patterns the way deductive arguments do. Rather, induction is the term applied to various sorts of arguments, such as arguments by "), _c('i', [_vm._v("analogy ")]), _vm._v("(used, e.g., in legal and moral reasoning), "), _c('i', [_vm._v("causal ")]), _vm._v("arguments, "), _c('i', [_vm._v("statistical ")]), _vm._v("and "), _c('i', [_vm._v("probabilistic ")]), _vm._v("arguments, and "), _c('i', [_vm._v("hypothetical ")]), _vm._v("arguments (used, e.g., in scientific reasoning). We will comment briefly on only two of these sorts of arguments: probability and hypothetical reasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Probability")]), _vm._v(". Inductive arguments are often formulated in terms of the "), _c('i', [_vm._v("probability calculus")]), _vm._v(". Theorists have discovered specific rules for determining the probability of a statement’s truth (or an event’s occurrence) based on the probability of other statements being true (or other events occurring). While the details are beyond the scope of this book, something called "), _c('i', [_vm._v("Bayes’ theorem ")]), _vm._v("is often used, a formula that evaluates the conditional probability of two or more mutually exclusive and jointly exhaustive statements or events."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" What we need to determine in instances of probabilistic inductive reasoning (whether using Bayes’ theorem or not) is the nature of the probabilities assigned. If the probabilities are objective (e.g., the probability of drawing a club from a full deck of cards) and if the sample size is sufficiently "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("large (e.g., the number of smokers who contracted lung cancer out of a study group of 100,000 people), then the probability calculus yields a strong inductive argument. On the other hand, the probabilities may represent "), _c('i', [_vm._v("epistemic probability")]), _vm._v(", a subjective assignment of the degree of belief or confidence placed in the premise (e.g., the probability that the amount and kinds of evil observed in the world would exist given the existence of a good, omniscient, omnipotent God). In many such cases the epistemic probabilities depend more on the arguer’s worldview than on anything objectively quantifiable, and in other cases the probabilities are downright inscrutable. Probabilities of this sort yield weaker inductive arguments.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Hypothetical reasoning")]), _vm._v(". A different sort of inductive reasoning is "), _c('i', [_vm._v("hypothetical")]), _vm._v(", often used in scientific (and criminal) investigation but also widely used in daily life. Here we are confronted with a problem of some sort, certain observations or data that need explanation. We form a hypothesis based on the observations, then draw out implications of the hypothesis and devise tests of the implications. If things come out as expected, the hypothesis is confirmed; if not, it is disconfirmed. (Note that because this is an inductive form of argument, the hypothesis is not proved or disproved.) A closely related form of argument is "), _c('i', [_vm._v("inference to the best explanation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In many (perhaps most) cases, when confronted by a problem to be solved, a number of live hypotheses could explain the data, not just one. It is often impractical or even impossible to construct independent tests to confirm or disconfirm the various live hypotheses, so from the pool of hypotheses that explain the data, we infer which one is the best explanation. Several different criteria enter into an inference to the best explanation, including the following:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("◉")]), _vm._v(" explanatory power—the best hypothesis will explain the observed data better, making the data more probable (epistemically) than its rivals")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("◉")]), _vm._v(" scope—the best hypothesis explains a wider range of data (e.g., observations from other experiments or other crimes) than its rivals")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("◉")]), _vm._v(" fertility—the best hypothesis will generate more possibilities for new research than its rivals")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("◉")]), _vm._v(" less ad hoc—the best hypothesis will involve fewer new assumptions not implied by other theories than will its rivals")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("◉")]), _vm._v(" coherence with accepted theory—the best hypothesis will agree with a wider variety of accepted theories than its rivals")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("◉")]), _vm._v(" simplicity—other things being equal, the best hypothesis will be simpler than its rivals")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Clearly it will be rare if one explanation comes out ahead on all of these criteria; knowing how to judge and rank the different criteria is more a matter of art, gained through experience working in a particular field.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("METHOD")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As we indicated above, careful definition of terms is essential for good arguments. How many times have you heard someone say (or you’ve said yourself), “We’re just arguing over semantics”? Too often the statement is meant dismissively, as if there were nothing really at stake in the argument. But semantics has to do with "), _c('i', [_vm._v("meaning")]), _vm._v(", and so an argument about semantics is important, one that cries out for careful definitions. The histories of both theology and philosophy are filled with arguments about meanings and with attempts by different thinkers to state carefully what they mean. So we need to pay attention to definitions in this section.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We will also need to pay attention to what has been called "), _c('i', [_vm._v("conceptual analysis")]), _vm._v(", which amounts to a fancy way to get at the meaning of a concept. Together with argument and definition, conceptual analysis is one of the most useful tools in the philosopher’s toolbox.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Definitions. ")])]), _vm._v("The primary interest of philosophers is not in the definitions of words in general, but in "), _c('i', [_vm._v("terms")]), _vm._v("—a word or group of words that may serve as the subject of a statement. Proper nouns, common nouns, and descriptive phrases are all terms.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Lexical definition")]), _vm._v(". It would be natural to look in a dictionary to see how a term is defined. But—and this point may be so obvious that it is often overlooked—a lexical definition is a definition of a word, not of a thing. This will become clearer as we consider other types of definitions. Another way of looking at the matter is by way of distinguishing "), _c('i', [_vm._v("intensional ")]), _vm._v("(with an "), _c('i', [_vm._v("s")]), _vm._v(") from "), _c('i', [_vm._v("extensional ")]), _vm._v("meanings. The intension of a term is what it connotes, while the extension of a term is what it denotes. The intension is the concept, while the extension consists in the class of things that fall under the concept.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_c('i', [_vm._v("Intensional definition")]), _vm._v(". An intensional definition of a term specifies the "), _c('i', [_vm._v("essence ")]), _vm._v("of the object the term refers to. Often this is done, following Aristotle, by specifying a genus and a species—that is, by specifying a general class and then the difference that sets the specific term off from other things that are also part of the genus. Aristotle’s classic example was that “man” connoted a “rational animal,” where “animal” was the genus and “rational” was what differentiated man from all other animals.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Extensional definition")]), _vm._v(". An extensional definition specifies the "), _c('i', [_vm._v("class of things ")]), _vm._v("in the world that the term picks out. Sometimes this is done "), _c('i', [_vm._v("ostensively")]), _vm._v(", by pointing (“This, that, and that one over there are my children”), and sometimes it is done by giving the requirements for membership in the extension class, the conditions that are "), _c('i', [_vm._v("individually necessary and jointly sufficient ")]), _vm._v("for an object to fall under the concept. This is the common method since it is usually impractical or impossible to point to all the members of the extension class. (Note that some terms have a clear, intensional definition—e.g., a unicorn is “a white horse-like creature with one horn”—but no extension. We say the extension of such terms is empty.)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One more word about "), _c('i', [_vm._v("necessary and sufficient conditions")]), _vm._v(". A necessary condition is a property without which an object will not fall under a concept, while a sufficient condition is a property the presence of which locates the object under the concept.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Stipulative definitions")]), _vm._v(". Sometimes an author will specify the precise sense in which she is using a term that is capable of several meanings, or she may give a particular technical sense to a term that generally does not bear that sense. Such stipulations are a legitimate practice, especially when done for the purpose of avoiding equivocations.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Conceptual analysis. ")])]), _vm._v("Philosophers generally see a large part of their work to be that of conceptual analysis. When doing conceptual analysis, most philosophers are not so much interested in how a term is used in the language as they are in discovering the essence of that to which the concept applies. So, for example, if we ask the question, “What is justice?” the answer will be found in an analysis of the concept of justice—seeking what justice consists in, what its essence is—and not simply in an analysis of the ways in which the word is used or in an examination of the things to which the term is applied (for some of them, it might turn out, are misapplications of the term). The process of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("conceptual analysis is often carried on through progressively refining the analysis, seeking out possible counterexamples and then re-refining. It may seem tedious, perhaps, but remember that the goal is clarity and precision.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("PHILOSOPHY A")]), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("ND THEOLOGY")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If you are reading this book, the chances are that you already sense something of what philosophy has to do with theology. We want to mention three ways in which the two disciplines interact that we think are especially important for pastors, seminarians, Christian workers, and, indeed, all thinking Christians to consider.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Understanding worldviews. ")])]), _vm._v("In the words of James W. Sire,")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("A worldview is a commitment, a fundamental commitment of the heart, that can be expressed as a story or in a set of presuppositions (assumptions which may be true, partially true or entirely false) which we hold (consciously or subconsciously, consistently or inconsistently) about the basic constitution of reality, and that provides the foundation on which we live and move and have our being."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Critical thinking about worldviews is a philosophical matter, and worldviews likewise influence how philosophy is done. As we noted above, the cogency of an argument for a particular person is often more a matter of that person’s worldview than of the philosophical strength of the argument. We believe that as Christians, we should examine our own worldview, ferreting out the implications of our Christian faith for all aspects of our lives. And since worldviews largely determine a person’s “plausibility structure” (the background against which proposed beliefs or ideas are evaluated), we believe that it is crucial for evangelism that Christians should become familiar with the basic tenets of the worldviews of those around us.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Setting the agenda. ")])]), _vm._v("The philosophical problems and solutions on offer at any given time go far to determine the agenda for theology at that time. This is not to say that theology does not in part set its own agenda. But it is clear from the history of theology that philosophical questions have strongly influenced its trajectory. For example, when the Council of Nicaea declared in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("325 that the Son was “of the same substance” with the Father, or when in 451 the Council of Chalcedon explained how Jesus can be both God and man in terms of “one person, two natures,” the language reflected philosophical concerns with terms such as "), _c('i', [_vm._v("essence")]), _vm._v(", "), _c('i', [_vm._v("substance")]), _vm._v(", "), _c('i', [_vm._v("nature")]), _vm._v(", and "), _c('i', [_vm._v("attribute")]), _vm._v(". And the contemporary debate over open theism reflects philosophical concerns with the nature of free will, the meaning of omniscience, the nature of time, and the epistemic or metaphysical status of propositions about future free actions—concerns that have shaped theological discussion. Because theology must always keep one eye on apologetic issues of the time, philosophical awareness will always be a requirement for doing theology.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Sharing methodology. ")])]), _vm._v("A final area where philosophy and theology overlap is in method. The careful definition and conceptual analysis characteristic of philosophy also characterize the best theology. Common theological terms such as "), _c('i', [_vm._v("substance")]), _vm._v(","), _c('i', [_vm._v(" essence")]), _vm._v(","), _c('i', [_vm._v(" hypostatic union")]), _vm._v(","), _c('i', [_vm._v(" person")]), _vm._v(","), _c('i', [_vm._v(" soul")]), _vm._v(","), _c('i', [_vm._v(" omniscience")]), _vm._v(","), _c('i', [_vm._v(" omnipotence")]), _vm._v(","), _c('i', [_vm._v(" foreknowledge")]), _vm._v(","), _c('i', [_vm._v(" eternity")]), _vm._v(","), _c('i', [_vm._v(" infallibility")]), _vm._v(","), _c('i', [_vm._v(" inerrancy")]), _vm._v(", and so on need to be defined precisely, used unequivocally, and defended carefully. In addition to having the knowledge and skills required for biblical exegesis and for historical and theological reflection, a good theologian must also have some skill in philosophical methodology.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Both of us believe we are better philosophers because of our theological study, and we believe equally that our theological abilities have been sharpened by our philosophical work. Our goal, our hope, our prayer is that this book will help you as well.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 69
// module chunks = 0